import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Whirlpool2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WHIRLPOOL2;
}

export default Whirlpool2PoiTileEntity;
